<template>
	<div class="logo" @click="clickLogo">
		<router-link to="/">bme</router-link>
	</div>
</template>

<script>
	export default {
		name: 'Logo',
		data() {
			return {
				thisUrl: null
			}
		},
		created() {
			this.thisUrl = this.$router.currentRoute.path;
		},
		methods: {
			clickLogo() {
				if (this.thisUrl === '/' || this.thisUrl === '/login') window.location = '/';
			}
		}
	}
</script>

<style lang="scss" scoped>
	div {
		border-right: 1px solid #ececec;
		width: 127px;
		padding: 30px;
	}

	a {
		background: #38B7EA;
		color: #fff;
		padding: 4px;
		text-decoration: none;
		border-radius: 3px;
		display: block;
		width: 68px;
		text-align: center;
		font-size: 28px;
		font-family: 'Roboto', sans-serif;
	}
</style>
